import { Label } from "reactstrap";
import FileBase64 from 'react-file-base64';

import { SupportRequestFormInputProps } from "./SupportRequestModal";
import { FormGroup } from "reactstrap";
import { IFile, SupportTicket } from "../../../globals/interfaces";
import UploadAttachments from "./UploadAttachments";
import { ButtonGroup } from "reactstrap";
import { Button } from "reactstrap";
import { UseFormSetValue } from "react-hook-form";

interface Props {
    FormInput: SupportRequestFormInputProps;
    addAttachments: (files: Array<IFile>) => void;
    setValue: UseFormSetValue<SupportTicket>;
    type: string;
}

export default function CreateModalBody({
    FormInput,
    addAttachments,
    setValue,
    type
}: Props) {

    const types = ['EOS', 'IT', 'HR'];

    return (
        <div>
            <FormGroup>
                <Label className={'mr-2'}>Select Type:</Label>
                <ButtonGroup>
                    {
                        types.map(t => (
                            <Button 
                                key={t} 
                                onClick={() => setValue('type', t)}
                                active={type === t}
                            >
                                {t} Support
                            </Button>
                        ))
                    }
                </ButtonGroup>
            </FormGroup>
            <FormInput
                label={'Please describe your issue:'}
                name={'description'}
                type="textarea"
            />
            <UploadAttachments addAttachments={addAttachments} />
        </div>
    );
}